/* ============================================
   FOUR Amsterdam — Brand List Search
   Asset: assets/four-brand-list.js
   ============================================ */

(function () {
  var inputDesktop  = document.getElementById('brand-search');
  var inputMobile   = document.getElementById('brand-search-mobile');
  var countDesktop  = document.getElementById('search-count');
  var countMobile   = document.getElementById('search-count-mobile');
  var noResults     = document.getElementById('no-results');
  var noResultsText = document.getElementById('no-results-text');
  var groups        = document.querySelectorAll('.brand-group');

  function filter(query, countEl) {
    var totalVisible = 0;

    groups.forEach(function (group) {
      var items = group.querySelectorAll('.brand-item');
      var groupVisible = 0;

      items.forEach(function (item) {
        var nameEl = item.querySelector('a') || item.querySelector('.name');
        var name = nameEl ? nameEl.textContent.toLowerCase() : '';
        var match = !query || name.indexOf(query) !== -1;
        item.style.display = match ? '' : 'none';
        if (match) groupVisible++;
      });

      if (groupVisible > 0) {
        group.classList.remove('hidden');
        totalVisible += groupVisible;
      } else {
        group.classList.add('hidden');
      }
    });

    if (query) {
      countEl.textContent = totalVisible + (totalVisible === 1 ? ' brand' : ' brands');
      noResults.classList.toggle('visible', totalVisible === 0);
      if (totalVisible === 0) {
        noResultsText.textContent = 'No results for \u201c' + query + '\u201d';
      }
    } else {
      countEl.textContent = '';
      noResults.classList.remove('visible');
    }
  }

  if (inputDesktop) {
    inputDesktop.addEventListener('input', function () {
      filter(inputDesktop.value.trim().toLowerCase(), countDesktop);
    });
  }

  if (inputMobile) {
    inputMobile.addEventListener('input', function () {
      filter(inputMobile.value.trim().toLowerCase(), countMobile);
    });
  }
})();
